import React, { useEffect, useState } from 'react';
import './ContenedorConstanciasAlumnos.css';
import axios from 'axios';
import { mostrarCertificado, descargarCertificado } from '../Pages/constants';
import { useData } from '../Pages/DataContext';
import { QRCodeCanvas } from 'qrcode.react';

const DownloadIcon = () => (
  <svg aria-hidden="true" viewBox="0 0 24 24">
    <path d="M12 3v12m0 0 5-5m-5 5-5-5M5 21h14" />
  </svg>
);

const CertificateIcon = () => (
  <svg aria-hidden="true" viewBox="0 0 24 24">
    <path d="M7 3h7l5 5v7M14 3v5h5M8 13h6M8 17h4" />
    <path d="M6 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8" />
    <path d="m18 17 .8 1.6 1.7.3-1.2 1.3.3 1.8-1.6-.8-1.6.8.3-1.8-1.2-1.3 1.7-.3L18 17Z" />
  </svg>
);

const ContenedorConstanciasAlumnos = () => {
  const { data } = useData();
  const [certificados, setCertificados] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState('');
  const [descargandoId, setDescargandoId] = useState(null);

  useEffect(() => {
    const obtenerCertificados = async () => {
      if (!data?.matricula) {
        setCargando(false);
        return;
      }

      try {
        const response = await axios.get(mostrarCertificado, { params: { matricula: data.matricula } });
        const certificadosRecibidos = Array.isArray(response.data) ? response.data : [];

        setCertificados(certificadosRecibidos.map((item) => ({
          ...item,
          url: `${descargarCertificado}?id_archivo=${item.id_archivo}`,
        })));
        setError('');
      } catch (requestError) {
        setCertificados([]);
        setError('No pudimos cargar tus constancias. Intenta nuevamente más tarde.');
        console.error('Error al obtener las constancias:', requestError);
      } finally {
        setCargando(false);
      }
    };

    obtenerCertificados();
  }, [data?.matricula]);

  const handleDescargarCertificado = async (certificado) => {
    setDescargandoId(certificado.id_archivo);
    setError('');

    try {
      const response = await axios.get(certificado.url, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');

      link.href = url;
      link.setAttribute('download', certificado.nombre_archivo);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (requestError) {
      setError('No fue posible descargar la constancia. Intenta nuevamente.');
      console.error('Error al descargar la constancia:', requestError);
    } finally {
      setDescargandoId(null);
    }
  };

  if (cargando) {
    return (
      <div className="constancias-inicio-estado" aria-live="polite">
        <span className="constancias-inicio-cargador" />
        <strong>Cargando constancias</strong>
      </div>
    );
  }

  if (certificados.length === 0 && !error) {
    return (
      <div className="constancias-inicio-estado">
        <span className="constancias-inicio-icono constancias-inicio-icono-vacio"><CertificateIcon /></span>
        <strong>Aún no tienes constancias disponibles</strong>
        <p>Cuando se genere una para tu matrícula, aparecerá aquí.</p>
      </div>
    );
  }

  return (
    <div className="constancias-inicio">
      <div className="constancias-inicio-resumen">
        <span>Documentos académicos</span>
        <strong>{certificados.length} {certificados.length === 1 ? 'constancia disponible' : 'constancias disponibles'}</strong>
      </div>

      {error && <div className="constancias-inicio-error" role="alert">{error}</div>}

      <div className="constancias-inicio-lista">
        {certificados.map((certificado) => {
          const estaDescargando = descargandoId === certificado.id_archivo;

          return (
            <article className="constancia-inicio-card" key={certificado.id_archivo}>
              <span className="constancias-inicio-icono"><CertificateIcon /></span>
              <div className="constancia-inicio-datos">
                <span>Constancia académica</span>
                <h3 title={certificado.nombre_archivo}>{certificado.nombre_archivo}</h3>
                <p>Matrícula <strong>{certificado.matricula_alumno}</strong></p>
              </div>
              <div className="constancia-inicio-qr" aria-label="Código QR de la constancia">
                <QRCodeCanvas value={certificado.url} size={68} />
              </div>
              <button type="button" disabled={estaDescargando} onClick={() => handleDescargarCertificado(certificado)}>
                <DownloadIcon />
                {estaDescargando ? 'Descargando...' : 'Descargar'}
              </button>
            </article>
          );
        })}
      </div>
    </div>
  );
};

export default ContenedorConstanciasAlumnos;
